import { ModalsProvider, modals as mantineModals } from '@mantine/modals'
import { QueryClient, UseSuspenseQueryResult } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { useDetectAdBlock } from 'hooks/utils'
import { modals } from 'modals/modals'
import { Suspense, lazy, useEffect } from 'react'
import { Account } from 'types/auth'

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null // Render nothing in production
    : lazy(() =>
        // Lazy load in development
        import('@tanstack/react-router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      )

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
  account: UseSuspenseQueryResult<Account>
}>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <ModalsProvider modals={modals}>
      <RootComponentWithModals />
    </ModalsProvider>
  )
}

function RootComponentWithModals() {
  const isProduction = process.env.NODE_ENV === 'production'
  const isAdBlockDetected = useDetectAdBlock()

  function openAdBlockModal() {
    mantineModals.openContextModal({
      modal: 'adBlockDetected',
      size: 'md',
      centered: true,
      withCloseButton: false,
      closeOnClickOutside: false,
      closeOnEscape: false,
      autoFocus: false,
      trapFocus: false,
      innerProps: {},
    })
  }

  useEffect(() => {
    if (isAdBlockDetected && isProduction) {
      openAdBlockModal()
    }
  }, [isAdBlockDetected, isProduction])

  return (
    <>
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  )
}
